import Rabbit from "crypto-js/rabbit";

export function encrypt(clearMessage: string, secret: string) {
  return Rabbit.encrypt(clearMessage, secret).toString();
}
